import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { EffectCoverflow, Mousewheel, Navigation } from 'swiper';
import { projectsData } from "./Data";
import ProjectItems from "./ProjectItems";
import "./projects.css";

function Project() {
  return (
    <div className="container">
      <Swiper
        effect={'coverflow'}
        grabCursor={true}
        centeredSlides={true}
        centralizadoSlidesBounds={true}
        slidesPerView= {1}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 2.5,
          slideShadows: true,
        }}
        direction={'horizontal'}
        slideActiveClass='swiper-slide-ativo'
        navigation={true}
        mousewheel={true} // Habilita a navegação com o scroll do mouse
        modules={[EffectCoverflow, Mousewheel, Navigation]}
        className="swiper_container"
        breakpoints={{
          780: {
            slidesPerView: 1.3,
          },
        }}
        speed={600}
      >
        {projectsData.map((project, index) => (
          <SwiperSlide key={index}>
            <ProjectItems item={project} isActive={true} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default Project;